module.exports = __webpack_public_path__ + "img/bughunting.df3975bd.svg";